import Icon from '@mui/icons-material/Notifications'
import React from 'react'

import { ComponentWithSubheader } from 'dash/shared'
import { ChannelCreate } from './create'
import { ChannelEdit } from './edit'
import { ChannelList } from './list'

export default class Channel {
  static Create = () => (
    <ComponentWithSubheader path={['My Account', 'Channels']} label={`Create Channel`} component={ChannelCreate} />
  )
  static Edit = () => <ComponentWithSubheader path={['My Account', 'Channels']} label={`Edit Channel`} component={ChannelEdit} />
  static List = () => <ComponentWithSubheader path={['My Account']} label="Channels" component={ChannelList} />
  static Icon = Icon
}
